import { parseAppDate, toUTCDate } from "@/utils/dates/dateFormats";
import { setTimeToMidday, toLocaleTimezone } from "@/utils/dates/dateUtils";
import { HolidayTypeEnum } from "@altertec_gparn/lib";
import { Expose, Transform } from "class-transformer";
import { IsEnum, IsInt, IsOptional, IsString, Max, Min } from "class-validator";

export class CreateCollectiveAgreementHolidayDto {
  @Expose()
  @IsString()
  collectiveAgreementId: string;

  @Expose()
  @Transform(({ value }) => {
    const parsedUtc = parseAppDate(value, false);
    const localDate = toLocaleTimezone(parsedUtc);
    const localMidday = setTimeToMidday(localDate);
    return toUTCDate(localMidday);
  })
  date: string;

  @Expose()
  @Transform(({ value }) => {
    if (typeof value !== "string") return value;
    const trimmed = value.trim();
    return trimmed.length ? trimmed : undefined;
  })
  @IsOptional()
  @IsString()
  name?: string;

  @Expose()
  @IsEnum(HolidayTypeEnum)
  type: HolidayTypeEnum;

  @Expose()
  @IsInt()
  @Min(2000)
  @Max(2100)
  year: number;

  @Expose()
  @IsOptional()
  @IsString()
  description?: string;
}
